import { useEffect } from "react";
import PulseBg from "@assets/pulse/pulse-background.jpg";
import PulseBgMobile from "@assets/pulse/pulse-background-mobile.jpg";
import { useNavigateCarousel } from "@features/pulse/hooks/useNavigateCarousel";
import { useSetPulseArticle } from "@features/pulse/hooks/useSetPulseArticle";
import PulseLayout from "@features/pulse/layouts/PulseLayout";
import { getPulseCardGaProps } from "@features/pulse/utils/helpers";
import type { PulsePageContext } from "@features/pulse/utils/types";
import JsonLdSchema from "@features/seo/JsonLdSchema";
import { useInjectClientData } from "@hooks/useInjectClientData";
import { useWindowSize } from "@hooks/useWindowSize";

const PulsePageContent = ({
  data: { pulseArticles },
  gaProps,
  schema,
}: PulsePageContext): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  const { sortedPulseArticles } = useSetPulseArticle({
    pulseArticles,
  });

  const {
    offset,
    activeArticle,
    handleNavigateLeftCard,
    handleNavigateRightCard,
    handleSetActiveArticle,
  } = useNavigateCarousel({
    articleList: sortedPulseArticles,
  });

  const currentArticle = sortedPulseArticles[activeArticle - 1];

  const gaPropsAll = {
    ...gaProps,
    ...getPulseCardGaProps(currentArticle, activeArticle),
  };

  useInjectClientData({ gaProps: gaPropsAll });
  const imageUrl = isScreenLG ? PulseBg : PulseBgMobile;

  useEffect(() => {
    if (typeof window === "undefined") return;

    window.document.body.style.backgroundColor = "#0a0a0a";

    window.document.body.style.overflowY = "hidden";
  }, []);

  return (
    <div
      className="max-w-screen relative left-1/2 mx-auto flex h-svh w-screen -translate-x-1/2 flex-col overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${imageUrl})`,
      }}
    >
      {schema && schema.type === "others" ? (
        <JsonLdSchema schema={schema.props} />
      ) : null}

      <PulseLayout
        sortedPulseArticles={sortedPulseArticles}
        activeArticle={activeArticle}
        handleNavigateRightCard={handleNavigateRightCard}
        handleNavigateLeftCard={handleNavigateLeftCard}
        handleSetActiveArticle={handleSetActiveArticle}
        offset={offset}
      />
    </div>
  );
};

export default PulsePageContent;
